// src/pages/RecordRoom/index.jsx
import React from 'react';
import { useProfile } from 'context/ProfileContext';
import { useAppAccess } from 'context/AppAccessContext';
import Page from 'components/Page';
import SectionCard from 'components/SectionCard';

import AdminView from './AdminView';
import OrgView from './OrgView';

export default function RecordRoom() {
  const { profile, loading: profileLoading } = useProfile();
  const { apps, loading: appsLoading } = useAppAccess();

  // Defensive default in case apps is undefined on first pass
  const appList = Array.isArray(apps) ? apps : [];
  const hasAccess = !!(profile?.is_admin || appList.includes('record-room'));

  // Loading state
  if (profileLoading || appsLoading) {
    return <Page title="RecordRoom">Loading...</Page>;
  }

  // 🚨 Access guard
  if (!hasAccess) {
    return (
      <Page title="RecordRoom">
        <div className="p-6 text-muted">You do not have access to this app.</div>
      </Page>
    );
  }

  // Refresh callback for AdminView
  const handleUploadSuccess = () => {
    document.dispatchEvent(new Event('refresh-org-docs'));
  };

  return (
    <Page title="RecordRoom">
      {profile?.is_admin ? (
        <div className="space-y-6">
          <SectionCard title="Admin Tools">
            <AdminView onUploadSuccess={handleUploadSuccess} />
          </SectionCard>

          <SectionCard title="Documents">
            {/* ✅ Pass selectedOrg down for filter reset */}
            <OrgView />
          </SectionCard>
        </div>
      ) : (
        <SectionCard title="Documents">
          <OrgView />
        </SectionCard>
      )}
    </Page>
  );
}
